import { useI18n } from '@muse/i18n'

import { createLazyComponent } from '@muse-web/router'

import { OtherCreatorsSkeleton } from '../components/other-creators'

const loadOtherCreators = () =>
    import(/* webpackChunkName: 'audio-suggestions' */ './OtherCreatorsContainer')

const OtherCreatorsFallback = () => {
    const { t } = useI18n()

    return <OtherCreatorsSkeleton title={t('i18n.otherCreatorsTitle')} />
}

export const AsyncOtherCreatorsContainer = createLazyComponent(
    loadOtherCreators,
    'OtherCreatorsContainer',
    { keepServerMarkup: true, fallback: OtherCreatorsFallback },
)
